module.exports = "/_next/static/images/projectTechnologyDeployment3-8ee121c371a5c529b6caf9edce0c84fe.webp";